import { useOpointAuth } from '@opoint/authjs-react';
import { useEffect, useState } from 'react';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Assignment } from '../types';
import { updateAssignment } from '../api';

interface AssignmentEditModalProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    assignment: Assignment | undefined;
    assignments: Assignment[];
    setAssignments: (assignments: Assignment[]) => void;
}

const AssignmentEditModal = (props: AssignmentEditModalProps) => {
    const { isOpen, setIsOpen, assignment, assignments, setAssignments } = props;
    const auth = useOpointAuth();
    const [instruction, setInstruction] = useState(assignment !== undefined ? assignment.instruction : '');
    const [comment, setComment] = useState(assignment !== undefined ? assignment.comment : '');
    useEffect(() => {
        setInstruction(assignment !== undefined ? assignment.instruction : '');
        setComment(assignment !== undefined ? assignment.comment : '');
    }, [assignment]);
    if (assignment === undefined) return null;
    return (
        <>
            <Dialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        if (assignment.id_assignment === undefined) 
                            return;
                        updateAssignment(
                            auth, 
                            assignment.id_assignment,
                            {
                                instruction,
                                comment
                            }
                        );
                        setAssignments(
                            assignments.map(
                                (a) => a.id_assignment === assignment.id_assignment
                                ? {
                                    ...a,
                                    instruction,
                                    comment,
                                }
                                : a
                            )
                        );
                        setIsOpen(false);
                    },
                }}
            >
                <DialogTitle>Edit assignment</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="instruction"
                        name="instruction"
                        label="Instruction"
                        type="text"
                        fullWidth
                        multiline
                        variant="standard"
                        value={instruction}
                        onChange={(event) => setInstruction(event.target.value)}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="comment"
                        name="comment"
                        label="Comment"
                        type="text"
                        fullWidth
                        multiline
                        variant="standard"
                        value={comment}
                        onChange={(event) => setComment(event.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit">Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AssignmentEditModal;